import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { InputField } from '../input';

import './searchField.scss';

type Props = {
  disabled: boolean;
  placeholder?: string;
  search?: string;
  setSearch: (search: string) => void;
  testId?: string;
};

export const SearchField: FC<Props> = ({ disabled, placeholder, search, setSearch, testId }) => {
  const { t } = useTranslation();

  return (
    <InputField
      autoComplete="off"
      className="search-field"
      disabled={disabled}
      hasClearButton
      iconName="magnifyingSearchFilled"
      name="search"
      onChange={(value: string | number) => setSearch(`${value}`)}
      onClearClick={() => setSearch('')}
      placeholder={placeholder?.trim() ? placeholder : t('SHARED.PLACEHOLDER.SEARCH')}
      testId={testId}
      value={search}
    />
  );
};
